import axios from "axios";
import ToastMessage from "../../../components/toast";
import { COUNTY_WAGE, EARNING_CODE, SET_ERROR, SOH_SETTINGS, EARNING_CODES, SOH_TOOL } from "../../types"
export const MinWageAction = () => {
    return async (dispatch) => {
        await axios.get('api/listing/get-county-wages').then(response => {
            dispatch({
                type: COUNTY_WAGE,
                payload: response.data.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
};

export const EarningCodeAction = (payload) => {
    return async (dispatch) => {
        await axios.post('api/earning-codes/get-earning-codes-by-company-short-name', payload).then(response => {
            dispatch({
                type: EARNING_CODE,
                payload: response.data.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
            ToastMessage(e.message, "error");
        });
    };
};

export const getSOHSettings = companyId => {
    return async (dispatch) => {
        try {

            let settings = await getSettings(companyId);
            let earnings = await getEarnings(companyId);
            let { earningCodes } = settings;
            earningCodes = earningCodes || [];
            let sohEarnings = earnings.map(ear => {
                let settingsCode = earningCodes.find(sc => sc.code._id === ear._id);
                return { ...ear, ...(settingsCode || {}) };
            });
            settings.earningCodes = sohEarnings;
            dispatch({
                type: SOH_SETTINGS,
                payload: settings
            });
        } catch (e) {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        } {

        }
    };
};


async function getEarnings(company) {
    let earnings = await axios.get(`api/soh-tool/earning-codes/${company}`);
    return earnings.data;
};

async function getSettings(company) {
    let settings = await axios.get(`api/soh-tool/settings/${company}`);
    return settings.data;
};

export const saveSOHSettings = (companyId, payload) => {
    return async dispatch => {
        await axios.post(`api/soh-tool/settings`, { companyId, payload }).then(res => {
            dispatch({
                type: SOH_SETTINGS,
                payload: res.data
            });
            ToastMessage("Settings Successfully Saved!", "success");
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
            ToastMessage(e.message, "error")
        });
    };
};

export const getEarningCodes = company => {
    return async dispatch => {
        await axios.get(`api/soh-tool/earning-codes/${company}`).then(res => {
            dispatch({
                type: EARNING_CODES,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const newSOHTool = (payload) => {
    return async dispatch => {
        await axios.post('api/file-transform/soh-tool', payload).then(res => {
            dispatch({
                type: SOH_TOOL,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
            let erMsge = ["Earning Code Not Mapped, Please Contact SA", "Cost Center Not Mapped, Please Contact SA"];
            let mappedError = erMsge.find(msg => e.response?.data?.includes(msg));
            ToastMessage(mappedError || "Error loading file, Please contact SA", "error");
        });
    };
}